



































































































































































































































































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import BaseContainer from '@/components/BaseContainer.vue';
import StatusPanel from '@/views/Inquiry/components/StatusPanel.vue';
import BaseInfoPanel from '@/components/BaseInfoPanel.vue';
import { ProjectInquiry, Carrier } from '@/http';
import ButtonPanel from '@/components/ButtonPanel.vue';
import CspDialog from '@/components/CspDialog.vue';
import { PaginationPanel } from '@/components';
import { formRules } from '@/common/util/validator';
import { default as DataPanel } from '@/components/DataPanel.vue';
import publicFunc from '../../common/util/publicFunc';
import { ElStep } from 'element-ui/types/step';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        BaseContainer,
        StatusPanel,
        BaseInfoPanel,
        ButtonPanel,
        CspDialog,
        DataPanel,
        PaginationPanel,
    },
})
export default class InquiryDetailEng extends Vue {
    getRowKey(row) {
        return row.id;
    }
    headerStyle({ row, column, rowIndex, columnIndex }: any) {
        // row[3].colSpan = 2;
        // row[4].colSpan = 0;
        // if (columnIndex === 4) {
        //     return 'display: none;';
        // }
        return {
            background: '#f8f9fb',
        };
    }
    public winVisible = false;
    public formDataWin: any = { winRemark: '' };
    public loading: boolean = false;
    public loading2: boolean = false;

    public adjustCarrierVisible = false;
    public requoteVisible = false;
    public activeName = 'first';
    public title: string = '1.在线查看询价信息以及询价进度  2.询价状态为报价中，支持制造企业一键催报、承运商重新报价等操作';
    public cspdiaConfig: any = {
        cspDialogVisible: false,
        title: '询价单终结',
        content: '确认终结询价单？',
    };
    public publicFunc: any = publicFunc;
    public formRules = formRules;
    public curCarrierBtnList = [];
    public id: any = '';
    public name: any = '';
    public detailData: any = {};
    public templates: any = [];
    public formDataRequote: any = {};
    public async created() {
        this.id = this.$route.query.id;
        this.name = this.$route.query.name;
        let res = await Carrier.GetList({ count: -1 });
        this.carrierList = res.data;
        this.reload();
    }

    public async init() {
        this.id = this.$route.query.id;
        this.name = this.$route.query.name;
        let res = await Carrier.GetList({ count: -1 });
        this.carrierList = res.data;
        this.reload();
    }

    async exportData() {
        await ProjectInquiry.ExportQuotes(this.id, {
            ...this.searchValue,
        });
    }

    handleClick(tab, event) {
        console.log(tab, event);
        if (tab.index == '1') {
            this.loadData();
        }
    }

    public async over() {
        await ProjectInquiry.FinishProjectInquiry(this.id);
        this.$message.success('操作成功!');
        this.$router.push('/singleInquiryEng');
    }

    public allCarrierBtnList: any = [];
    public allCarrierBtnListId: any = [];
    public tableList: any = [];
    public templates2: any = [];
    public inquiryCarrierList: any = [];
    public goodsList: any = [];
    async reload() {
        this.tableData = [];
        this.tableList = [];
        this.inquiryCarrierList = [];
        this.isChangeCarrier = false;
        ProjectInquiry.GetDetail(this.id).then(async (res) => {
            this.detailData = res;
            let skip = 0;
            this.detailData.goodsList.map((item, index) => {
                item.index = skip++ + 1;
            });
            this.goodsList = this.detailData.goodsList;
            this.inquiryCarrierList = res.inquiryCarrierList;
            if (this.detailData.statusStr == '已终结') {
                let res2: any = await ProjectInquiry.GetQuoteDetail(this.id, { count: -1 });
                this.templates = res2.data;
                this.carLengths = this.templates[0] ? this.templates[0].carLengths : [];
            }

            // let carLengthArr = res.carLength.split(',');
            // carLengthArr.forEach((item) => {
            //     this.tableList.push({
            //         carLength: item,
            //         price: '',
            //     });
            // });
            // this.detailData.inquiryQuotes.forEach((item) => {
            //     this.tableData.push({
            //         carrierName: item.carrierName,
            //         timesIndex: item.timesIndex,
            //         quotes: item.quotes,
            //         isWin: item.isWin,
            //     });
            // });
            this.formData.carrierIds = [];
            // res.inquiryCarrierList.forEach((item) => {
            //     this.formData.carrierIds.push(item.carrierId);
            // });
            this.dynamicTags = [];

            this.formData.carrierIds.forEach((item) => {
                let res = this.carrierList.filter((v) => v.id == item)[0];
                this.dynamicTags.push({
                    name: res.name,
                    id: res.id,
                });
            });

            this.allCarrierBtnList = [];
            this.allCarrierBtnListId = [];
            this.carrierList.forEach((i) => {
                this.allCarrierBtnList.push(i.name);
                this.allCarrierBtnListId.push({
                    id: i.id,
                    name: i.name,
                });
            });
            this.loadData();
        });
    }
    public carLengths: any = [];
    public async mounted() {}
    public spanArr = [];
    public pos = 0;
    getSpanArr(data) {
        // this.spanArr = [0,2,0,1,0,2,0,1];
        this.spanArr = [];
        let temp = [];
        for (var i = 0; i < data.length; i++) {
            temp.push('_');
            for (var j = 0; j < data[i].projectQuotes.length; j++) {
                temp.push(data[i].projectQuotes[j].carrierName);
            }
        }
        for (var i = 0; i < temp.length; i++) {
            if (temp[i] == '_') {
                this.spanArr.push(1);
                this.pos = 0;
            } else {
                // 判断当前元素与上一个元素是否相同  inAccessCode（批次字段）
                if (temp[i] === temp[i - 1]) {
                    this.spanArr[this.pos] += 1;
                    this.spanArr.push(0);
                } else {
                    this.spanArr.push(1);
                    this.pos = i;
                }
            }
        }

        console.log('temp' + JSON.stringify(temp));
        console.log('spanArr' + JSON.stringify(this.spanArr));
    }
    fn2(arr) {
        var result = [],
            i = 0;
        result[i] = [arr[0]];
        arr.reduce(function (prev, cur) {
            cur.carrierName === prev.carrierName ? result[i].push(cur) : (result[++i] = [cur]);
            return cur;
        });
        console.log('result' + result.length);
        return result;
    }

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 3) {
            const _row = this.spanArr[rowIndex];
            const _col = _row > 0 ? 1 : 0;
            return {
                rowspan: _row,
                colspan: _col,
            };
        }
    }

    public searchValue: any = {
        startPlace: '',
        endPlace: '',
        winCarrier: '',
    };
    resetSearchValue() {
        this.searchValue = {
            startPlace: '',
            endPlace: '',
            winCarrier: '',
        };
        this.searchFunc();
    }
    labelPosition = 'right';
    public rePagin = false;
    public total = 0;
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        this.loadData();
    }

    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public $refs: {
        formData: HTMLFormElement;
        pagination: HTMLFormElement;
        formDataWin: HTMLFormElement;
        multipleTable2: HTMLFormElement;
    };
    public async loadData() {
        this.loading2 = true;
        this.carLengths = [];
        console.log('.');
        try {
            let res = await ProjectInquiry.GetQuoteDetail(this.id, {
                skip: this.searchPagin.skip,
                count: this.searchPagin.count,
                ...this.searchValue,
            });

            res.data.forEach((item) => {
                item.projectQuotes.forEach((i, j) => {
                    i.id = this.guid();
                    if (j == item.projectQuotes.length - 1) {
                        i.isLast = true;
                    }
                    if (item.winCarrierId == i.carrierId && i.isWin) {
                        item.quotes = JSON.parse(JSON.stringify(i.quotes));
                    }
                });
            });
            let temp = res.data;
            console.log(temp, '33445566');
            this.carLengths = temp[0] ? temp[0].carLengths : ['4.2米及以下', '6.8米', '9.6米', '17.5米', '12.5米'];
            this.templates2 = [];
            this.$nextTick(() => {
                this.templates2 = temp;
                this.getSpanArr(this.templates2);
                //在数据加载完，重新渲染表格
                this.$refs['multipleTable2'].doLayout();
            });

            this.total = res.total;
            this.loading2 = false;
        } catch (err) {
            this.loading2 = false;
        }
    }

    guid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0,
                v = c == 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
    searchFunc() {
        this.loadData();
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
    }
    public requoteClose() {
        this.requoteVisible = false;
    }

    public async saveRequote() {
        if (this.currentBtn.length == 0) {
            this.$message.warning('请选择承运商');
        } else {
            let carrierIds = [];
            this.currentBtn.forEach((i) => {
                let res = this.allCarrierBtnListId.filter((v) => v.name == i)[0];
                if (res) {
                    carrierIds.push(res.id);
                }
            });
            await ProjectInquiry.BackQuote({
                projectInquiryId: this.id,
                carrierIds: carrierIds,
            });
            this.$message.success('定向询价承运商调整成功！');
            this.$router.push('/SingleInquiryEng');
        }
    }

    public isChangeCarrier = false;
    public changeCarrier() {
        this.isChangeCarrier = true;
    }
    public formData: any = { carrierIds: [] };
    public dynamicTags = [];
    handleDelTag(tag) {
        let flag = true;
        try {
            this.detailData.inquiryQuotes.forEach((i) => {
                if (i.carrierName == tag.name) {
                    flag = false;
                    this.$message.warning('该承运商已报价，无法删除!');
                    throw Error();
                }
            });
        } catch (e) {}
        if (flag) {
            this.formData.carrierIds = [];
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
            this.dynamicTags.forEach((item) => {
                this.formData.carrierIds.push(item.id);
            });
            this.oldData = JSON.parse(JSON.stringify(this.formData.carrierIds));
        }
    }
    public carrierChange(data) {
        let flag = true;
        let arr1 = [];
        let arr2 = [];
        if (this.formData.carrierIds.length >= this.oldData) {
            arr1 = this.formData.carrierIds;
            arr2 = this.oldData;
        } else {
            arr1 = this.oldData;
            arr2 = this.formData.carrierIds;
        }
        let res = [];
        res.push(
            arr1.filter((item) => {
                return !arr2.includes(item);
            })
        );
        try {
            this.detailData.inquiryQuotes.forEach((i) => {
                if (i.carrierId == res[0]) {
                    flag = false;
                    this.$message.warning('该承运商已报价，无法删除!');
                    this.formData.carrierIds = JSON.parse(JSON.stringify(this.oldData));
                    throw Error();
                }
            });
        } catch (e) {}
        if (flag) {
            this.dynamicTags = [];
            this.formData.carrierIds.forEach((item) => {
                let res = this.carrierList.filter((v) => v.id == item)[0];
                this.dynamicTags.push({
                    name: res.name,
                    id: res.id,
                });
            });
            this.oldData = JSON.parse(JSON.stringify(this.formData.carrierIds));
        }
    }
    public tableData: any = [];
    public colData: any = [];

    public oldData: any = [];
    //调整承运商
    adjustCarrier() {
        this.adjustCarrierVisible = true;
        this.oldData = JSON.parse(JSON.stringify(this.formData.carrierIds));
        this.dynamicTags = [];

        this.formData.carrierIds.forEach((item) => {
            let res = this.carrierList.filter((v) => v.id == item)[0];
            this.dynamicTags.push({
                name: res.name,
                id: res.id,
            });
        });
    }
    //一键催报
    async reminder() {
        await ProjectInquiry.Urge(this.id);
        this.$message.warning('单笔询价催报成功！');
    }
    //承运商重新报价
    requote() {
        this.requoteVisible = true;
        let currBtnName = [];
        this.inquiryCarrierList.forEach((item) => {
            currBtnName.push(item.carrierName);
        });
        this.currentBtn = currBtnName;

        this.curCarrierBtnList = [];
        this.currentBtn.forEach((i) => {
            let res = this.allCarrierBtnList.filter((v) => v == i)[0];
            if (res) {
                this.curCarrierBtnList.push(res);
            }
        });
    }
    //一键否决
    reject() {
        // this.$confirm('承运商报价全部拒绝!', '一键否决', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(() => {
        //         ProjectInquiry.RejectAllQuote(this.id).then(() => {
        //             this.$message.success('单笔询价招标失败！');
        //             this.$router.push('/SingleInquiry');
        //         });
        //     })
        //     .catch(() => {});
    }
    loadingEffect = [];
    public winTip: any = '';
    public winRemark: any = '';

    public timesIndex: any = '';
    public tag = false;
    public carrierId: any = '';
    public templateId: any = '';
    public bidding(row, tag) {
        console.log('row' + JSON.stringify(row));
        this.tag = tag;

        this.carrierId = row.quotes[0].carrierId;
        this.templateId = row.quotes[0].templateId;
        if (tag) {
            this.timesIndex = row.timesIndex;
            let str = '';
            row.quotes.forEach((item) => {
                if (item.price) {
                    str += item.carLength + '中标价:' + item.price+'元/车' + ' , ';
                }
            });
            // str = str.substring(0, str.lastIndexOf(','));
            this.winTip = str + '   确认' + row.carrierName + '中标?';
        } else {
            this.timesIndex = row.quotes[0].timesIndex;
            this.winTip = '确认取消' + row.quotes[0].carrierName + '中标?';
        }

        this.formDataWin.winRemark = '';
        this.winVisible = true;
    }
    public async saveWin() {
        if (this.tag) {
            await ProjectInquiry.Win({
                projectInquiryId: this.id,
                carrierId: this.carrierId,
                timesIndex: this.timesIndex,
                templateId: this.templateId,
                winRemark: this.formDataWin.winRemark,
            });
            this.$message.success('询价单招标成功！');
            this.winVisible = false;
            this.init();
            // this.$router.push('/SingleInquiryEng');
        } else {
            this.$refs.formDataWin.validate(async (valid) => {
                if (valid) {
                    await ProjectInquiry.CancelWin({
                        projectInquiryId: this.id,
                        carrierId: this.carrierId,
                        timesIndex: this.timesIndex,
                        templateId: this.templateId,
                        cancelRemark: this.formDataWin.winRemark,
                    });
                    this.$message.success('询价单取消成功!');
                    this.winVisible = false;
                    // this.$router.push('/SingleInquiryEng');
                    this.init();
                }
            });
        }
    }
    winClose() {
        this.winRemark = '';
        this.winTip = '';
        this.winVisible = false;
    }
    cellClass({ row, column, rowIndex, columnIndex }) {
        // if (this.detailData.statusStr == '招标成功') {
        // }
        if (row.isWin && columnIndex != 0 && columnIndex != 1 && columnIndex != 2 && columnIndex != 3 && columnIndex != column.length - 1) {
            return 'background-color:#fff;color:#06A774';
        } else {
            return '';
        }
    }

    /**新增询价单 */
    public async addInquiry() {
        this.dialogBtn = 'save';
        this.cspdiaConfig = {
            cspDialogVisible: true,
            title: '询价单发布',
            content: '确认发布询价单？',
        };
    }

    editInquiry() {
        this.$router.push({
            path: '/addInquiryEng',
            query: {
                id: this.id,
                type: 'edit',
            },
        });
    }
    public dialogBtn: string = '';
    public dialogConfig2 = {
        title: '',
        show: false,
    };
    public dialogConfig3 = {
        title: '',
        show: false,
    };
    confirmClose2() {
        this.dialogConfig2 = {
            title: '',
            show: false,
        };
    }
    confirmClose3() {
        this.dialogConfig3 = {
            title: '',
            show: false,
        };
    }
    /**终结询价单 */
    confirmOk3() {
        ProjectInquiry.EndProjectInquiry(this.id).then(() => {
            this.$message.success('询价单终结成功');
            this.$router.push('/SingleInquiryEng');
        });
        this.dialogConfig3 = {
            title: '',
            show: false,
        };
    }
    endInquiry() {
        this.dialogConfig3 = {
            title: '终结询价单',
            show: true,
        };
        // this.$confirm('确认终结该询价单?', '询价单终结', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(() => {
        //         ProjectInquiry.EndProjectInquiry(this.id).then(() => {
        //             this.$message.success('询价单终结成功');
        //             this.$router.push('/SingleInquiryEng');
        //         });
        //     })
        //     .catch(() => {});
    }
    /**删除询价单 */
    confirmOk2() {
        ProjectInquiry.DelProjectInquiry(this.id).then(() => {
            this.$message.success('询价单删除成功');
            this.$router.push('/SingleInquiryEng');
        });

        this.dialogConfig2 = {
            title: '',
            show: false,
        };
    }
    deleteInquiry() {
        this.dialogConfig2 = {
            title: '删除询价单',
            show: true,
        };
        // this.$confirm('确认删除该询价单?', '询价单删除', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(() => {
        //         ProjectInquiry.DelProjectInquiry(this.id).then(() => {
        //             this.$message.success('询价单删除成功');
        //             this.$router.push('/SingleInquiryEng');
        //         });
        //     })
        //     .catch(() => {});
    }

    public currentBtn: any = [];

    public editForm: any = {};
    public fileList: any = [];
    public goodsForm: any = {};

    cspdiaClose() {}

    back() {
        this.$router.push('/singleInquiryEng');
    }

    viewFile(item) {
        if (publicFunc.getExtension2(item.name)) {
            window.open(`https://view.officeapps.live.com/op/view.aspx?src=${item.path}`);
        } else {
            window.open(item.path);
        }
    }
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }
    public processStatus: boolean = false;
    public processList = [];
    public takeTime = null;
    public firData = null;
    public SecData = null;
    public d: number = 0;
    public h: number = 0;
    public m: any = 0;
    public s: any = 0;
    public time: string = '';
    public timer: any = null;

    async getprocess(e) {
        // e.stopPropagation();
        // this.processStatus = !this.processStatus;
        // if (this.processStatus) {
        //     this.processList = [];
        //     let res = await ProjectInquiry.GetTracks(this.id);
        //     this.processList = res.reverse();
        //     this.takeTime = this.processList[0].time;
        //     this.firData = this.processList[0].time;
        //     this.SecData = this.processList[this.processList.length - 1].time;
        //     this.countTime();
        //     // if (this.status != '已送达' && this.status != '已终结') {
        //     //     this.countTime();
        //     // } else {
        //     //     this.countTime2();
        //     // }
        //     console.log('this.processList' + JSON.stringify(this.processList));
        // }
    }

    countTime() {
        //获取当前时间
        var date = new Date();
        var now = date.getTime();
        //设置截止时间
        var endDate = new Date(Date.parse(this.takeTime.replace(/-/g, '/')));
        var end = endDate.getTime();
        //时间差
        var leftTime = now - end;
        //定义变量 d,h,m,s保存倒计时的时间

        this.d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        this.h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        this.m = Math.floor((leftTime / 1000 / 60) % 60);
        this.s = Math.floor((leftTime / 1000) % 60);
        this.time = '耗时' + this.d + '天' + this.h + '小时' + this.m + '分' + this.s + '秒';
        this.timer = setTimeout(this.countTime, 1000);
    }

    countTime2() {
        var nowData = new Date(Date.parse(this.firData.replace(/-/g, '/')));
        var now = nowData.getTime();
        var endDate = new Date(Date.parse(this.SecData.replace(/-/g, '/')));
        var end = endDate.getTime();
        var leftTime = now - end;
        //定义变量 d,h,m,s保存倒计时的时间
        console.log('leftTime' + leftTime);

        this.d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        this.h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        this.m = Math.floor((leftTime / 1000 / 60) % 60);
        this.s = Math.floor((leftTime / 1000) % 60);
        this.time = '耗时' + this.d + '天' + this.h + '小时' + this.m + '分' + this.s + '秒';
    }
    @Watch('processStatus')
    processStatusChange() {
        if (this.processStatus == false) {
            if (this.timer) {
                clearTimeout(this.timer);
            }
        }
    }

    public carrierList = [];
    getCarrierList() {
        // CspInquiry.getLoadType({ typeName: '装车要求' }).then((res) => {
        //     this.carrierList = res.map((v) => {
        //         return v.stringData;
        //     });
        // });
    }
    updateBtn(item, index) {
        console.log('item' + JSON.stringify(item));
        if (this.currentBtn.includes(item)) {
            this.currentBtn.splice(this.currentBtn.indexOf(item), 1);
        } else {
            this.currentBtn.push(item);
        }
        console.log('this.currentBtn' + JSON.stringify(this.currentBtn));
    }

    downLoad(path) {
        window.open(path);
    }

    expands: any = [];
    // 每次只展示一行
    expandSelect(row, expandedRows) {
        // 当没有展开行时
        if (expandedRows.length > 0) {
            // 先清空展开行数组
            this.expands = [];
            // 把当前行的id放到展开行数组中（data中getRowKeys获取的是什么这里就push什么）
            this.expands.push(row.id);
        } else {
            // 清空存放目前展开行的数组
            this.expands = [];
        }
    }

    clickBtn() {
        console.log('阻止单击事件继续传播');
    }

    clickRow(row) {
        this.$refs.multipleTable2.toggleRowExpansion(row);
        // 如果仅为点击展开 传第二个参数为true
        // this.$refs.expandTable.toggleRowExpansion(row, true)
    }

    public paginationOptions = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public pageSizes = [10];
    public lastPageNum = 0;
    public pageSize: number = 10;
    public firstPageBtnDisabled = true;
    public lastPageBtnDisabled = false;
    public handleCurrentChange(val) {
        console.log('onPaginationChange', val);
        this.firstPageBtnDisabled = val === 1 ? true : false;
        this.lastPageBtnDisabled = val === Math.ceil(this.total / this.paginationOptions.count) ? true : false;
        this.paginationOptions.currentPage = val;
        this.paginationOptions.skip = (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
        console.log('this.paginationOptions~', this.paginationOptions);
    }
    public handleSizeChange(val) {
        console.log('handleSizeChangeval' + JSON.stringify(val));

        this.paginationOptions.count = val;
        this.paginationOptions.currentPage = 1;
        this.handleCurrentChange(this.paginationOptions.currentPage);
        if (Math.ceil(this.total / val) < this.paginationOptions.currentPage) {
            this.paginationOptions.skip = 0;
        } else {
            this.paginationOptions.skip = (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
        }
    }
}
